import classNames from 'classnames';
import type { Control, FieldValues } from 'react-hook-form';

import Field from '~/shared/components/field';
import type { FormFieldType } from '~/shared/types/form-type';

import './form-group.scss';

type Props = {
  formField: FormFieldType;

  fieldConfig?: {
    name?: string;
  };

  errors: Record<string, unknown>;

  getValues: (fieldName?: string) => unknown;

  setValue: (fieldName: string, value: unknown, options?: Record<string, unknown>) => void;

  watch: (fieldName?: string) => unknown;

  control: Control<FieldValues>;
};

const FormGroup = ({ formField, fieldConfig, setValue, watch, getValues, control, errors }: Props) => {
  return (
    <div className={classNames('form-group', formField.className)}>
      {formField.label && <div className="form-group__title">{formField.label}</div>}

      <div className="form-group__content">
        {(formField.children ?? []).map((childField) => (
          <Field
            key={childField.name}
            formField={childField}
            fieldConfig={fieldConfig}
            setValue={setValue}
            watch={watch}
            getValues={getValues}
            control={control}
            errors={errors}
          />
        ))}
      </div>
    </div>
  );
};

export default FormGroup;
